import {Component, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {CandeactivateDialogComponent} from './candeactivate-dialog.component';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class CanDeactivateGuard {
  constructor(public dialog: MatDialog) {}
  canDeactivate(
    component: CanComponentDeactivate,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    if (!component.canDeactivate()) {
      let dialogRef: MatDialogRef<CandeactivateDialogComponent> = this.dialog.open(
        CandeactivateDialogComponent,
      );
      return dialogRef.afterClosed();
    } else {
      return true;
    }
  }
}
